import { CoachingTranscriptShallow } from '../../../../../coaching-base/general';
import { BehaviourItem } from '../../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../../coaching-tags/models/subbehaviour.coaching.model';
import { TranscriptBehaviourView } from '../model/transcript-behaviour-view.model';
import { TranscriptData } from '../model/transcript-data.model';

export function transcriptDataTransformer(
    val: CoachingTranscriptShallow,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): TranscriptData {
    const focuses =
        val.focuses?.map<TranscriptBehaviourView>((e) => ({
            behaviourId: e.behaviourId,
            behaviourName: behaviours?.find((ee) => ee.id === e.behaviourId)
                ?.name,
            subBehaviourId: e.subBehaviourId,
            subBehaviourName: subBehaviours?.find(
                (ee) =>
                    ee.id === e.subBehaviourId &&
                    ee.behaviourId === e.behaviourId,
            )?.name,
            isPrimary: e.isPrimary,
        })) ?? [];
    return {
        title: val.name,
        transcriptId: val.transcriptId,
        description: val.description,
        createdDateTime: val.createdOn,
        primaryFocus: focuses.find((e) => e.isPrimary === true),
        behaviours: focuses.filter((e) => e.isPrimary !== true),
        participants: val.participants?.map(
            (e) => e.userName ?? e.msftDisplayName,
        ),
        isOpen: null,
        startDate: val.startDate,
        endDate: val.endDate,
        statusId: val.statusId,
    };
}
